module.exports = __webpack_public_path__ + "static/media/pincode.e6ebd874.svg";